import { QueryKey, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAxios } from 'context/AxiosContextProvider';

import config from '../../config';

export interface useDeleteActivityLogMessageMutationArguments {
  id: number;
}
export default function useDeleteActivityLogMessageMutation(queryKey: QueryKey) {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (parameter: useDeleteActivityLogMessageMutationArguments) => {
      return axios.delete(`${config.apiBaseUrl}/op/v1/comments/${parameter?.id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
}
